export default __webpack_public_path__ + "bfx/static/media/close.39cad648.svg";